import React from "react";
import { HONEYPOT_FIELD } from "../../../constants/contactOptions";

/**
 * A field no human ever sees, and therefore never fills in. If it arrives with
 * a value, whatever submitted the form was not a browser rendering our CSS.
 *
 * The details matter more than they look:
 *
 *  - Off-screen positioning, not `display: none` and not `type="hidden"`.
 *    Both of those are the first things a competent scraper skips, which is
 *    exactly backwards from what we want.
 *  - `tabIndex={-1}` keeps it out of keyboard navigation, so a sighted
 *    keyboard user never lands in it by tabbing.
 *  - `aria-hidden` keeps it out of the accessibility tree, so a screen reader
 *    never announces it. A honeypot that traps real users is worse than none.
 *  - `autoComplete="off"` stops a password manager helpfully filling it.
 *
 * The server treats a filled honeypot as a signal, never as grounds for
 * rejection — see middlewares/botCheck.js.
 */
export default function Honeypot({ value, onChange }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <label htmlFor={HONEYPOT_FIELD}>
        Leave this field empty
        <input
          id={HONEYPOT_FIELD}
          type="text"
          name={HONEYPOT_FIELD}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />
      </label>
    </div>
  );
}
